import Download from "../page/Download";

const DownloadSection = () => {
    return (
        <section
            id="download"
            data-section
            data-title="Download"
            aria-label="Download"
            className="relative w-full min-h-screen"
        >
            <Download />
        </section>
    );
};

export default DownloadSection;
